import {RootState} from "../../store";

export const changePasswordResultSelector = (state: RootState) => {
    return state.changePassword.records.result;
};
